module.exports = __webpack_public_path__ + "img/icon_my.2b40b04.webp";